import { ThreeApp } from "../work-modules/027/app";

export const main = async () => {
  const canvas = document.getElementById("webgl-canvas") as HTMLCanvasElement;

  // canvas要素の存在確認
  if (!canvas) {
    console.error("Canvas要素 (id: webgl-canvas) が見つかりません");
    return;
  }

  const app = new ThreeApp(canvas);

  await app.init();
  app.load().then(() => {
    app.setupModel();
    app.render();
  });
};
document.addEventListener("DOMContentLoaded", main);
